import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvcImgComponent } from './svc-img.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  imports: [CommonModule, NgxSkeletonLoaderModule],
  declarations: [SvcImgComponent],
  exports: [SvcImgComponent],
})
export class SvcImgModule {}
